import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from '../common/react-redux-hooks';
import GenericToggleSwitch from '../common/GenericToggleSwitch';
import { CAC_VIEW_PANEL_CARD_DISPLAY } from './CacConstants';
import { cacUpdateSwitchPanel, cacUpdateClusterSwitchPanel } from '../../actions/cacActions';
import { CAC_VIEW_PANEL_SWITCH_LIST } from '../../util/cacUtils';

const CacSwitchPanel = props => {
  const { mapView, aType } = props;
  const activeSwitch = mapView ? 1 : 0;
  const dispatch = useDispatch();

  const switches = [...CAC_VIEW_PANEL_SWITCH_LIST]; // copy the list

  // disable map
  // temporary code for release 1.29.0 (sprint 65)
  if (aType === "cluster") {
    const enableInDevOnly = () => {
      const local =
        window.location.hostname === 'local.dev.insights.mrisimmons' ||
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === '' ||
        window.location.hostname === 'dev.insights.mrisimmons' ||
        window.location.hostname === 'qa1.insights.mrisimmons';
      if (local) return true;
      return process.env.NODE_ENV === 'development';
    };

    switches[1].enabled = enableInDevOnly();
  } else switches[1].enabled = true;

  const handleAction = () => {
    switch(aType) {
      default: break;
      case "corr": dispatch(cacUpdateSwitchPanel()); break;
      case "cluster": dispatch(cacUpdateClusterSwitchPanel()); break;
    }
  };

  return (
    <Fragment>
      <GenericToggleSwitch
        title={CAC_VIEW_PANEL_CARD_DISPLAY}
        switchArray={switches}
        activeSwitch={activeSwitch}
        perfomedFunc={handleAction}
        data-test="GenericToggleSwitch"
      />
    </Fragment>
  );
};

CacSwitchPanel.propTypes = {
  mapView: PropTypes.bool,
  aType: PropTypes.string,
};

export default CacSwitchPanel;
